import type { Theme } from "@repo/tokens";

export const MATRIX_SELECT_ICON_WIDTH = 20;
export const MATRIX_SELECT_ICON_HEIGHT = 14;

export function getMatrixDataCellStyle(
  theme: Theme,
  isAttempted: boolean,
  userMap: Record<number, number>,
  correctMap: Record<number, number>,
  rowIdx: number,
  colIdx: number,
) {
  const { colors } = theme;
  const isUserSelected = userMap[rowIdx] === colIdx;
  const correctColIdx = correctMap[rowIdx];

  const correct = {
    borderColor: colors.success[60],
    backgroundColor: colors.success[95],
    textColor: colors.success[60],
  };
  const wrong = {
    borderColor: colors.error[60],
    backgroundColor: colors.error[95],
    textColor: colors.error[60],
  };
  const neutral = {
    borderColor: theme.border.default,
    backgroundColor: colors.neutral[100],
    textColor: theme.text.secondary,
  };
  const selected = {
    borderColor: colors.neutral[20],
    backgroundColor: colors.neutral[90],
    textColor: colors.neutral[20],
  };

  if (isAttempted) {
    const isCorrectCell = correctColIdx === colIdx;
    if (isUserSelected && isCorrectCell) return correct;
    if (isUserSelected && !isCorrectCell) return wrong;
    if (!isUserSelected && isCorrectCell) return correct;
    return neutral;
  }

  return isUserSelected ? selected : neutral;
}
